// Aktif Etsy magazasi. Coklu magaza destegi: tum Etsy cagrilari secili
// magazaya gider (ApiClient X-Shop-Id basligini otomatik ekler).

import { create } from "zustand";
import { apiClient } from "../lib/api";
import { authHeaders, getBackendUrl } from "../lib/http";

const ACTIVE_SHOP_KEY = "erc_active_shop";

export interface EtsyShopDto {
  id: string;
  platform: string;
  vertical: string;
  externalShopId: string;
  shopName: string;
  apiKey: string;
  sharedSecret: string;
  tokenExpires: string | null;
  tokenExpired: boolean;
  isActive: boolean;
  isDefault: boolean;
  /** IP sIkI mod: Yakin/Benzer sadakat kapali */
  ipStrict?: boolean;
  label: string | null;
  color: string | null;
  lastError: string | null;
  lastSyncAt: string | null;
  createdAt: string;
  shopUrl: string | null;
}

interface ShopState {
  shops: EtsyShopDto[];
  activeShopId: string | null;
  isLoading: boolean;

  loadShops: () => Promise<void>;
  setActiveShop: (shopId: string | null) => void;
}

// Modul yuklenirken senkron hidrasyon — ilk render'da dogru magaza ile istek
// yapilsin (auth.store ile ayni yaklasim).
const storedShopId = localStorage.getItem(ACTIVE_SHOP_KEY);
if (storedShopId) apiClient.setShopId(storedShopId);

function persist(shopId: string | null) {
  if (shopId) localStorage.setItem(ACTIVE_SHOP_KEY, shopId);
  else localStorage.removeItem(ACTIVE_SHOP_KEY);
  apiClient.setShopId(shopId);
}

export const useShopStore = create<ShopState>((set, get) => ({
  shops: [],
  activeShopId: storedShopId,
  isLoading: false,

  loadShops: async () => {
    set({ isLoading: true });
    try {
      const res = await fetch(`${getBackendUrl()}/api/etsy/shops`, { headers: authHeaders() });
      if (!res.ok) throw new Error("Mağazalar alınamadı");
      const body = await res.json();
      const shops: EtsyShopDto[] = body.data || [];

      // Secili magaza silinmis/pasife alinmissa varsayilana veya ilk aktife dus
      const current = shops.find((s) => s.id === get().activeShopId);
      const fallback = shops.find((s) => s.isActive && s.isDefault) || shops.find((s) => s.isActive);
      const nextId = current?.isActive ? current.id : fallback?.id ?? null;

      if (nextId !== get().activeShopId) persist(nextId);
      set({ shops, activeShopId: nextId, isLoading: false });
    } catch {
      set({ isLoading: false });
    }
  },

  setActiveShop: (shopId) => {
    persist(shopId);
    set({ activeShopId: shopId });
  },
}));

// React Query anahtarlarinda kullanilir: magaza degisince cache karismasin.
export function useActiveShopId() {
  return useShopStore((s) => s.activeShopId);
}
